import { Modal, Typography, Button } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { ReactComponent as DangerIcon } from 'assets/danger.svg';

const UnsupportedModal = (props) => {
   
    return (
        <Modal
            open={props?.openModal}
            onClose={() => props?.closeOpenModal()}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Box sx={{ display: "flex",minWidth: {xs:"12rem",md:"17.06rem"}, flexDirection: "column", justifyContent: "center", alignItems: "center", padding: 4, backgroundColor: 'white', borderRadius: "12px" }}>
                <DangerIcon style={{ width: '100px', height: '100px' }} />
                <Typography sx={{ fontSize: "16px", color: "#000000",textAlign:"center",marginTop:"-15px" ,marginBottom:"10px"}} variant="h8">Unsupported File Type! <br />
                    Please Try Again</Typography>
                <Button
                    sx={{
                        borderRadius: 4,
                        minWidth: 90,
                        minHeight: 42,
                        background: "#EF7D00",
                        marginTop: "13px",
                        "&:hover": {
                            backgroundColor: "#EF7D00",
                        },
                    }}
                    variant="contained"
                    type="button"
                    onClick={() => props?.closeOpenModal()}
                >OK
                </Button>
            </Box>
        </Modal>
    )
}

export default UnsupportedModal;
